import { Component } from "react";
import { storageGet, storageSet } from "@/lib/api";

const CHUNK_RE = /ChunkLoadError|Loading chunk|Loading CSS chunk|dynamically imported module|Importing a module script failed/i;
const RELOAD_KEY = "ws_chunk_reload_at";

// Catches render crashes so one broken screen never blanks the whole portal.
// Stale lazy chunks after a redeploy trigger a single automatic reload.
export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    const isChunk = CHUNK_RE.test(`${error?.name} ${error?.message}`);
    const last = Number(storageGet(sessionStorage, RELOAD_KEY) || 0);
    if (isChunk && Date.now() - last > 15000) {
      storageSet(sessionStorage, RELOAD_KEY, String(Date.now()));
      window.location.reload();
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md rounded-sm border border-slate-200 bg-white p-8 text-center shadow-sm">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-400">Agent Portal</div>
          <h2 className="mt-2 font-display text-xl text-slate-900">Something went wrong on this screen</h2>
          <p className="mt-2 text-sm text-slate-500">The rest of the portal is unaffected. Reload the page to try again.</p>
          <div className="mt-5 flex justify-center gap-2">
            <button onClick={() => window.location.reload()} data-testid="error-boundary-reload"
              className="rounded-sm bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-700">Reload</button>
            <button onClick={() => { window.location.href = "/"; }} data-testid="error-boundary-home"
              className="rounded-sm border border-slate-200 px-4 py-2 text-sm text-slate-600 hover:border-slate-900 hover:text-slate-900">Go to home</button>
          </div>
        </div>
      </div>
    );
  }
}
